import { render } from "./SchemaBuilderView.vue?vue&type=template&id=388b228c"
import script from "./SchemaBuilderView.vue?vue&type=script&lang=js"
export * from "./SchemaBuilderView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__